import { Component, OnInit, AfterContentChecked } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { UserSessionService } from '../../services/user-session.service';
import * as $ from 'jquery';
import { LINKS } from '../../_mocks/links';

// declare const $: any;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterContentChecked {

  routes = LINKS;

  title: string;
  icon: string;
  iconMenu = 'menu';

  constructor(
    private location: Location,
    private userSession: UserSessionService,
    private route: Router
  ) { }

  ngOnInit() {
    this.getTitle();
  }

  ngAfterContentChecked() {
    this.getTitle();
  }

  getTitle() {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(2);
    }
    titlee = titlee.split('/').pop();
    for (let item = 0; item < this.routes.length; item++) {
      const path = this.routes[item].path.split('/').pop();
      if (path === titlee) {
        this.title = this.routes[item].title;
        this.icon = this.routes[item].icon;
      }
    }
  }

  toggleMenu() {
    $('.wrapper-left').toggleClass('show-left');
    $('.content-fluid').toggleClass('show-fluid');
    if (this.iconMenu === 'menu') {
      this.iconMenu = 'clear';
    } else {
      this.iconMenu = 'menu';
    }
  }

  logout() {
    localStorage.removeItem("user");
    localStorage.removeItem('access_token');
    this.userSession.changeUser(false);
    this.route.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts